import { SET_PRESET_GAIN, SELECT_PLAY_MODE, SET_MIDI_NOTE_LENGTH, SET_DAMP_THRESHOLD } from './actionTypes'

import { matchSensitivityPreset } from '../utilities'

import { setSensitivityPreset } from './editorActions'

export const setPresetGain = (gain) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_PRESET_GAIN, gain: gain })
        // check sensitivity preset
        setTimeout(() => {
            const sensitivityPreset = matchSensitivityPreset(getState()).then(preset => {
                console.log('playability:sensitivityPreset', preset, getState().currentPreset.gain)
                dispatch(setSensitivityPreset(preset))
            })
        }, 500)
    }
};
export const selectPlayMode = (mode) => ({ type: SELECT_PLAY_MODE, mode: mode });
export const setMIDINOteLength = (length) => ({ type: SET_MIDI_NOTE_LENGTH, length: length });
export const setDampThreshold = (threshold) => ({ type: SET_DAMP_THRESHOLD, threshold: threshold });
